export default {
    fund: [{
            "title": "相关系数越小，组合曲线越往左边弯曲，组合风险（　　），组合效用（　　）。",
            "question": "A. 越大越低\nB. 越小越高\nC. 越小越低\nD. 越大越高",
            "answer": "B",
            "explain": "本题考查资产收益的相关性。相关系数越小，组合的曲线越往左边弯曲，组合风险越小（即在相同收益率的情况下，风险更小），组合的效用（对于投资者的满意程度）越高。"
        },
        {
            "title": "下列哪项业务对基金管理人的投资交易影响最大（　　）。",
            "question": "A. 基金份额的变动很大\nB. 基金业绩报酬计提方式的变更\nC. 基金发生非交易过户\nD. 基金投资者结构的变化",
            "answer": "A",
            "explain": "本题考查基金投资交易的影响因素。A选项符合题意，基金份额变动很大会对基金管理人的投资交易产生很大影响。"
        },
        {
            "title": "刘先生3月1日买入A股票1000股，共支付8000元，5月13日该股票公积金转增股本每10股送1股，10月13日发放股利0.1元/股，年末股价是9.9元。截至年末，刘先生持有该股票的收益率是（　　）。",
            "question": "A. 37.5%\nB. 25%\nC. 9.9%\nD. 23.75%",
            "answer": "A",
            "explain": "本题考查股票的收益性。刘先生最初购买价是8000÷1000=8元/股。5月13日每10股送1股，刘先生一共拥有1000+100=1100股。10月13号发放红利0.1元/股，1100×0.1=110元。年末股价是9.9元，持有该股票的收益率为（110+1100×9.9-8000）/8000=0.375"
        },
        {
            "title": "关于场内证券交易结算原则，以下表述错误的是（　　）。",
            "question": "A. 在共同对手方制度下，即使买卖双方中的一方不能履约，结算机构也要向守约一方先行垫付其应收的证券或资金\nB. 根据中国结算公司深圳分公司的规定，开立非担保结算备付金账户的机构，交易所场内证券发行资金通过非担保结算备付金账户划拨\nC. 根据货银对付原则，一旦结算参与人未能履行对证券登记结算机构的资金交收义务，结算机构就可以暂不向其交付其买入的证券\nD. 根据分级结算原则，当证券登记结算机构作为共同对手方提供多边净额结算服务时，结算机构负责与结算参与人之间的集中清算交收",
            "answer": "B",
            "explain": "本题考查场内证券交易结算原则。针对不同的证券交易品种，证券登记结算机构可以作为共同对手方，提供净额结算服务，在交收过程中为守约方提供交收担保。"
        },
        {
            "title": "某混合型基金A包括股票、债券和银行定期存款，各类资产的比例分别为70%、25%、5%，若下一年上述各类资产的预期收益率分别为20%、8%、1.75%，则基金A在下一年的期望收益率为（　　）。",
            "question": "A. 9.92%\nB. 19.87%\nC. 14.23%\nD. 16.09%",
            "answer": "D",
            "explain": "本题考查预期收益率即期望收益率的计算。投资组合预期收益率的计算公式为：E(rp)=∑Wi×E(ri)，式中，E(rp)为投资组合的期望收益率，E(ri)为第i个资产的收益率，Wi为第i个资产的权重，n为资产数目。E(rp)=(70%×20%)+(25%×8%)+(5%×1.75%)=16.09%。"
        },
        {
            "title": "接受境内机构投资者的委托进行境外证券投资的境外投资顾问，经营投资业务应在（　　）年以上，且最近一个会计年度管理的证券资产不少于（　　）亿美元或等值货币。",
            "question": "A. 10;100\nB. 10;200\nC. 5;200\nD. 5;100",
            "answer": "D",
            "explain": "本题考查进行境外证券投资的投资顾问的条件。接受境内机构投资者的委托进行境外证券投资的境外投资顾问应满足，经营投资管理业务达5年以上，最近一个会计年度管理的证券资产不少于100亿美元或等值货币。"
        }, {
            "title": "关于可转换债券有如下的表述：\nI、可转换债券简称可转债，是指一段时期内，持有者可以按照约定的转换价格或转换比率将其转换成普通股的公司债券\nII、可转换债券是一种混合债券，既包含了普通债权的特征，也包含了权益的特征\nIII、可转换债券是一种含有转股权的特殊债券\nIV、可转换债券的基本要素包含：标的股票、票面利率、转换期限、转换价格、转换比率、赎回条款、回售条款等\n以上四项表述中，正确的个数是（　　）。",
            "question": "A. 3\nB. 4\nC. 1\nD. 2",
            "answer": "B",
            "explain": "本题考查可转换债券的概念。"
        },
        {
            "title": "在港股通机制下，可接受内地投资者委托网香港联合交易所申报买卖的机构是（　　）。",
            "question": "A. 深圳证券交易所\nB. 香港证券交易所\nC. 上海证券交易所\nD. 内地证券公司",
            "answer": "D",
            "explain": "本题考查港股通。所调港股通，就是投资者委托内地证券服务分司，经由上海证券交易所或深圳证券交易所设立的证券交易服务公司，向香港联合交易所进行申报，买卖规定范围内的香港联合交易所上市的股票。"
        },
        {
            "title": "关于开放式基金的分红，以下表示错误的是（　　）。",
            "question": "A. 每一份基金份额享有同等分配权\nB. 可以采用现金分红方式或者分红再投资转换为基金份额的方式\nC. 收益分配方案、时间和发放方法都是分红公告中应当包含的主要内容\nD. 如果基金份额持有人事先没有做出选择，则基金收益分配默认转为基金份额。",
            "answer": "D",
            "explain": "本题考查基金利润的分配。开放式基金分红是指基金管理人根据基金利润情况，按投资者持有基金份额数量的多少进行利润分配。我国开放式基金按规定需在基金合同中约定每年基金利润分配的最多次数和基金利润分配的最低比例。同时要求基金收益分配后基金份额净值不能低于面值。每一基金份额享有同等分配权。开放式基金的分红方式有两种："
        },
        {
            "title": "某机构希望在F公司盈利较多时，获得较高的股利收益，则一般情况下，该机构应该投资F公司发行的哪一种金融工具（　　）。",
            "question": "A. 普通股\nB. 长期债券\nC. 累积优先股\nD. 非累积优先股",
            "answer": "A",
            "explain": "本题考查股票的种类。A选项符合题意，普通股的收益权是指普通股股东享有公司盈余和剩余财产的分配权，股利根据公司净利润的多少来决定，完全随公司盈利的变化而变化。"
        },
        {
            "title": "下列关于销售利润率的说法中，最准确的是（　　）。",
            "question": "A. 薄利多销会使得销售利润率下降，从而降低净利润\nB. 一般来说，当其他条件不变时，销售利润率越高越好，但当其他条件可变时，销售利润率降低并不一定意味着净利润总额降低\nC. 提高产品价格是企业提高净利润的最佳策略\nD. 缩减营业成本是企业提高净利润的最佳策略",
            "answer": "B",
            "explain": "本题考查财务比率分析。一般来说，其他条件不变时，销售利润率越高越好；但当其他条件可变时，销售利润率低也并不总是坏事，因为如果总体销售收入规模很大，还是能够取得不错的净利润总额，薄利多销就是这个道理。"
        },
        {
            "title": "在私募股权基金有限合伙制下，下列关于普通合伙人表述中，正确的是（　　）。",
            "question": "A. 普通合伙人的唯一收入来源是基金管理费\nB. 普通合伙人不参与基金的盈利分红\nC. 普通合伙人具备独立的经营管理权力\nD. 普通合伙人对私募股权基金承担有限连带责任",
            "answer": "C",
            "explain": "本题考查私募股权投资的组织形式。在有限合伙制当中，普通合伙人主要代表整个私募股权投资基金对外行使各种权利，对私募股权基金承担无限连带责任，收入来源是基金管理费和盈利分红。"
        }, {
            "title": "利率互换的两种形式是（　　）。",
            "questions": "I. 息票互换<br>II. 基础互换<br>III. 本金互换<br>IV. 利息互换",
            "question": "A. I、III\nB. I、II\nC. II、III\nD. II、IV",
            "answer": "B",
            "explain": "本题考查利率互换的类型。利率互换指互换合约双方同意在约定期限内按不同的计算方式分期向对方支付由币种相同的名义本金额所确定的利息，包括息票互换（I项符合题意）、基础互换（II项符合题意）。"
        },
        {
            "title": "关于期货市场的作用，以下表述错误的是（　　）。",
            "question": "A. 提供分散、转移价格风险的工具，有助于稳定国民经济\nB. 农产品期货市场有助于减缓农产品价格波动对农业发展的不利影响\nC. 期货交易需要对大量信息进行加工，故期货交易形成的未来价格信号具有滞后性\nD. 期货交易所形成的未来价格信号能反映多种生产要素在未来一定时期的变化趋势",
            "answer": "C",
            "explain": "本题考查期货市场的功能。A选项表述正确，提供分散、转移价格风险的工具，有助于稳定国民经济，这体现了期货市场风险管理的功能。B选项表述正确，期货市场的最基本的功能就是风险管理，农产品期货市场有助于减缓农产品现货市场的风险，降低现货市场价格波动对农业发展的不利影响。C选项表述错误，期货市场上来自各个地方的交易者带来了大量的供求信息，标准化合约的转让又增加了市场的流动性，期货市场中形成的价格能够及时反映市场供求关系的变化。"
        },
        {
            "title": "在弱有效市场中，证券价格能充分反映的信息为（　　）。",
            "question": "A. 所有公开信息\nB. 历史列中证券的价格、交易量等\nC. 所有历史信息、当下信息、以及预期的信息\nD. 未公开发布的内部信息",
            "answer": "B",
            "explain": "本题考查弱有效市场反映的信息。弱有效市场是指证券价格能够充分反映价格历史序列中包含的所有信息，如证券的价格、交易量等。在一个弱有效的证券市场上，任何为了预测未来证券价格走势而对以往价格、交易量等历史信息所进行的技术分析都是徒劳的，B选项符合题意。"
        },
        {
            "title": "普通股股东享有的基本权利，包括（　　）。",
            "questions": "I. 剩余收益的要求权<br>II. 表决权<br>III. 优先清偿权<br>IV. 监管权",
            "question": "A. I、II、III\nB. II、III\nC. I、II\nD. III、IV",
            "answer": "C",
            "explain": "本题考查普通股股东享有的基本权利。普通股即公司通常发行的无特别权利的股票，是最主要的权益类证券，普通股股东享有股东的基本权利，包括收益权（I项符合题意）和表决权（II项符合题意）。"
        },
        {
            "title": "以下关于固定收益证券综合电子平台的表述，错误的是（　　）。",
            "question": "A. 固定收益平台的现券交易实行净价申报\nB. 固定收益证券现券交易价格实行涨跌幅限制，涨跌幅比例为10%\nC. 证券申报价格变动单位为0.001元\nD. 当日买入的固定收益证券，当日不可卖出",
            "answer": "D",
            "explain": "本题考查固定收益证券综合电子平台。A、C选项表述正确，在固定收益平台进行的固定收益证券现券交易实行净价申报，申报价格变动单位为0.001元，申报数量为1手（1手为1000元面值）。B选项表述正确，固定收益平台进行的固定收益证券现券交易价格实行涨跌幅限制，涨跌幅比例为10%。D选项表述错误，交易商当日买入的固定收益证券，当日可以卖出。当日被待交收处理的固定收益证券，下一交易日可以卖出。"
        },
        {
            "title": "由某个或少数的某些资产有关的一些特别因素导致的风险，被称之为（　　）。",
            "question": "A. 单体风险\nB. 系统性风险\nC. 非系统性风险\nD. 人为风险",
            "answer": "C",
            "explain": "本题考查风险的种类。A选项不符合题意，单体风险。B选项不符合题意，系统性风险也可称为市场风险，是由经济环境因素的变化引起的整个金融市场的不确定性加强，其冲击是属于全面性的。C选项符合题意，非系统风险是可以通过构造资产组合分散掉的风险，往往是由与某个或少数的某些资产有关的一些特别因素导致的，只对某个或某些资产的收益造成影响，而与其他资产的收益无关。"
        }, {
            "title": "基金管理人对外披露基金净值前，负有复核基金净值准确性义务的机构是（　　）。",
            "question": "A. 基金公司稽核监督部门\nB. 第三方销售机构\nC. 相关监管机构\nD. 托管人",
            "answer": "D",
            "explain": "本题考查基金托管人的职责。托管人按基金合同规定的估值方法、时间、程序对基金管理人的计算结果进行复核，复核无误后签章返回给基金管理人，由基金管理人对外公布。"
        },
        {
            "title": "资本市场理论的前提假设包括（　　）。",
            "questions": "I. 所有投资者都是风险厌恶者<br>II. 所有投资者的期望相同<br>III. 所有投资可以无限分割，但是投资数量受到个体财富限制<br>IV. 投资者是价格的设定者",
            "question": "A. II、IV\nB. II、III、IV\nC. I、II\nD. I、II、IV",
            "answer": "C",
            "explain": "本题考查资本市场理论和资本资产定价模型前提假设。"
        },
        {
            "title": "小张2016年3月18日（周五）通过场外申购到1万份货币市场基金A的份额，同时成功赎回了1万份货币市场基金B的份额。下表为货币市场基金A和B在3月18日至3月21日期间的每日分配利润（按万份计算），在此期间，小张从基金A和B可以享有的基金分配利润总额是（　　）。",
            "question": "2016年3月18日周五0.60元\n2016年3月19日周六0.65元\n2016年3月20日周日0.61元\n2016年3月21日周一0.62元",
            "answer": "B",
            "explain": "本题考查货币市场基金利润分配的原则。"
        },
        {
            "title": "以下（　　）不影响投资者的风险承受能力。",
            "question": "A. 资产负债状况\nB. 投资期限\nC. 投资者的风险厌恶程度\nD. 现金流入",
            "answer": "C",
            "explain": "本题考查风险承受能力的影响因素。风险承受能力取决于投资者的情况，包括其资产负债状况（A选项不符合题意）、现金流入情况（D选项不符合题意）和投资期限（B选项不符合题意）。投资者的风险厌恶程度影响风险承担意愿，不影响投资者的风险承受能力。（C选项符合题意）"
        },
        {
            "title": "某公司从银行贷款100万元，年利率为8%，贷款期限为3年，到第3年末一次性还清，采取复利方式计算利息。以下表述正确的是（　　）。",
            "question": "A. 期末公司应付本利和为124万元\nB. 期末公司应付本利和为108万元\nC. 公司每一年新增的应付利息逐年递增\nD. 期末公司应付本利和为116万元",
            "answer": "C",
            "explain": "本题考查复利终值的计算。所谓复利，是指不仅本金要计利息，利息也要计利息，也就是通常所说的“利滚利”。用复利法计算时，每期期末计算的利息加入本金形成新的本金，再计算下期的利息，逐期滚利。期末公司应付本利和为：100×(1+8%)^3=125.97万。"
        },
        {
            "title": "赵先生2014年初买入股票共5000股，每股10元人民币，此后连续3年，每年该股每10股分红5元，期间赵先生持有该股的数量无变化，如果不考虑税收，则第三年分红后，赵先生累计获得多少分红收入（　　）。",
            "question": "A. 7500元\nB. 78813元\nC. 75000元\nD. 7881元",
            "answer": "A",
            "explain": "本题考查单利的计算。已知赵先生持有5000股股票，且每年每10股分红5元，则三年间该投资累计获得的分红收入为：5000÷10×5×3=7500元。"
        }, {
            "title": "关于投资者效用函数画出的无差异曲线，以下表达正确的是（　　）。",
            "question": "A. 同一条无差异曲线上的点所代表的效用水平并不必然相同\nB. 风险厌恶程度高的投资者与风险厌恶程度低的投资者相比，其无差异曲线更加陡峭\nC. 风险厌恶的投资者的无差异曲线是从左上方向右下方倾斜的\nD. 不同的无差异曲线也可以代表相同的效用水平",
            "answer": "B",
            "explain": "本题考查无差异曲线。A选项表述错误，同一条无差异曲线上的所有点向投资者提供了相同的效用。B选项表述正确，风险厌恶程度高的投资者与风险厌恶程度低的投资者相比，其无差异曲线更陡，因为随着风险增加，其要求的风险溢价更高。C选项表述错误，风险厌恶的投资者的无差异曲线是从左下方向右上方倾斜的。D选项表述错误，不同的无差异曲线代表不同的效用水平。"
        },
        {
            "title": "关于基金资产估值，以下表述错误的是（　　）。",
            "question": "A. 基金资产净值是计算投资者申购基金份额、赎回基金净额的基础，也是评价基金投资业绩的基础指标之一\nB. 基金资产总值是指基金全部资产的价值总和\nC. 基金资产估值是通过对基金所拥有的全部资产及全部负债按一定的原则和方法进行估算，进而确定基金资产公允价值的过程\nD. 从基金资产中扣除基金所有负债即是基金资产净值",
            "answer": "A",
            "explain": "本题考查基金资产估值的概念。A选项表述错误，基金份额净值（并非基金资产净值）是计算投资者申购基金份额，赎回资金金额的基础，也是评价基金投资业绩的基础指标之一。B选项表述正确，基金资产总值是指基金全部资产的价值总和。C选项表述正确，基金资产估值是通过对基金所拥有的全部资产及全部负债按一定的原则和方法进行估算，进而确定基金资产公允价值的过程。D选项表述正确，基金资产净值是指从基金资产中扣除基金所有负债。"
        },
        {
            "title": "抵押债券的抵押保证物可以是（　　）。",
            "question": "A. 债权\nB. 股权\nC. 不动产\nD. 以上三种都有可能",
            "answer": "C",
            "explain": "本题考查债券的受偿顺序。抵押债券的保证物是土地、房屋、设备等不动产；质押债券的保证物是债券发行者持有的债权或股权，而非真实资产；担保债券是由另一实体提供保证发行的债券。"
        },
        {
            "title": "某日，A投资者在场内申购了B货币ETF，则该笔交易适用的交收规则是（　　）。",
            "question": "A. T+1货银对付担保交收\nB. T+0连笔非担保交收\nC. T+0货银对付担保交收\nD. T+1逐笔非担保交收",
            "answer": "A",
            "explain": "本题考查货币ETF申购业务的交收规则。A选项符合题意，C选项不符合题意，目前，货银对付已经成为各国（地区）证券市场普遍遵循的原则。我国证券市场中，在多边净额结算方式下，已实现对ETF交易、单市场股票ETF及单市场债券ETF申购与赎回的份额和现金替代、货币ETF申购与赎回等业务进行T+1货银对付担保交收。B、D选项不符合题意，非担保交收是中国结算作为结算组织者、不作为共同对手方，按规则规定或结算双方约定的方式组织开展的交收。目前，采用逐笔非担保交收的品种有国债买断式回购购回交收、大宗交易专场业务交收、权证行权交收、专项资产管理计划转让等。"
        },
        {
            "title": "下列业务中，会降低企业短期偿债能力的是（　　）。",
            "question": "A. 企业向股东发放股票股利\nB. 企业向战略投资者进行定向增发\nC. 企业采用分期付款方式购置一台大型机械\nD. 企业从某国有银行取得3年期500万元的贷款",
            "answer": "C",
            "explain": "本题考查流动性比率。流动性比率是用来衡量企业短期偿债能力的比率，流动比率=流动资产÷流动负债。A选项不符合题意，企业向股东发放股票股利不会导致企业的流动资产流出，从而不影响企业的短期偿债能力。B选项不符合题意，企业向战略投资者进行定向增发为企业带来现金流，增加企业的短期偿债能力。"
        },
        {
            "title": "垃圾债券或高收益债，其投资级别属于（　　），该类债券还有较高的（　　）。",
            "question": "A. 投机级，利率风险\nB. 投资级，利率风险\nC. 投资级，信用风险\nD. 投机级，信用风险",
            "answer": "D",
            "explain": "本题考查债券评级。垃圾债券或高收益债券的投资级别属于投机级，该类债券的信用风险较高。"
        }, {
            "title": "对于投资收益率，我们用（　　）来衡量它偏离期望值的程度。",
            "question": "A. 中位数\nB. 方差或标准差\nC. 分位数\nD. 相关系数",
            "answer": "B",
            "explain": "本题考查方差或标准差的概念。方差和标准差用来衡量投资收益率偏离它期望值的程度，即投资回报的风险水平。"
        },
        {
            "title": "以下关于最大回撤的说法，正确的是（　　）。",
            "question": "A. 比较不同基金的最大回撤指标时，应尽量控制在同一个评估期间\nB. 最大回撤无法衡量损失的大小\nC. 最大回撤可以衡量损失发生的可能性\nD. 最大回撤可以衡量损失发生的概率",
            "answer": "A",
            "explain": "本题考查最大回撤。A选项说法正确，指定区间越长，最大回撤就越不利，因此在不同的基金之间使用该指标时，应尽量控制在同一个评估期间。B选项说法错误，D选项说法错误，最大回撤的缺点是只能衡量损失的大小（并非无法衡量损失的大小），而不能（并非可以）衡量损失发生的可能频率。C选项说法错误，最大回撤用于衡量投资管理人对下行风险（并非对上行风险以及下行风险）的控制能力。"
        },
        {
            "title": "关于另类投资的局限，以下表述错误的是（　　）。",
            "question": "A. 信息透明度低\nB. 估值难度大\nC. 杠杆率较高\nD. 流动性较好",
            "answer": "D",
            "explain": "本题考查另类投资的局限性。另类投资的局限性包括：（1）缺乏监管和信息透明度;(A选项表述正确） （2）流动性较差，杠杆率偏高：（C选项表述正确，D选项表述错误）"
        },
        {
            "title": "某企业2016年度的销售利润率为10%，年销售收入为10亿元，年均总资产为50亿元，权益乘数为200%，则该企业2016年度的净资产收益率为（　　）。",
            "question": "A. 4%\nB. 100%\nC. 2%\nD. 8%",
            "answer": "A",
            "explain": "本题考查净资产收益率的计算。净资产总额=销售利润率×销售收入总额=10%×10=1亿;所有者权益总额=资产总额/权益乘数=50/200%=25亿;净资产收益率=净利润总额/所有者权益总额=1/25=4%"
        },
        {
            "title": "以下选项中，不属于投资组合管理中规划步骤内容的是（　　）。",
            "question": "A. 监控和再平衡\nB. 制定投资政策说明书\nC. 确定并量化投资者的投资目标和投资限制\nD. 建立战略资产配置",
            "answer": "A",
            "explain": "本题考查规划环节的概念。规划步骤内容包括：确定并量化投资者的投资目标和投资限制制定投资政策说明书形成资本市场预期;建立战略资产配置。"
        },
        {
            "title": "基于金融经济变好的判断，张某计划进行大宗商品投资，他不希望花费运输和储存成本，同时希望在行情变化时通过交易所将投资资产卖出，张某可以选择的投资方式是（　　）。",
            "questions": "I. 购买大宗商品实物<br>II. 购买大宗商品相关股票<br>III. 购买大宗商品期指合约<br>IV. 购买其银行发行的大宗商品结构化产品",
            "question": "A. II、IV\nB. II、III\nC. I、IV\nD. I、III",
            "answer": "B",
            "explain": "本题考查大宗商品的投资方式。I项不符合题意，直接购买大宗商品实物进行投资会产生很大的运输成本和储存成本;"
        }, {
            "title": "关于各类大宗商品投资，以下表述正确的是（　　）。",
            "question": "A. 大豆、稻谷、小麦的期货被称为三大农产品期货\nB. 相比国外商品期货市场，国内商品期货市场，在石油、天然气等领域占据着定价权的制高点\nC. 目前国际上可交易的贵金属类大宗商品主要包括金、银、钨等\nD. 基础原材料类大宗商品是制造业发展的基础，与生产经营活动密切相关",
            "answer": "D",
            "explain": "本题考查大宗商品的类型。A选项表述错误，玉米、大豆、小麦的期货被称为三大农产品期货。B选项表述错误，相比国内，国际商品期货市场在石油、天然气等领域占据着大宗商品定价权的制高点。C选项表述错误，目前国际上可交易的贵金属类大宗商品主要包括黄金、白银、铂金等。"
        },
        {
            "title": "看跌期权买入开仓，收益情况为（　　）。",
            "question": "A. 损失无限，收益无限\nB. 损失有限，收益无限\nC. 损失无限，收益有限\nD. 损失有限，收益有限",
            "answer": "D",
            "explain": "本题考查期权合约的价值。看跌期权买入开仓，即买入看跌期权。（1）当标的资产的价格至盈亏平衡点以下时，看跌期权买方的最大盈利是执行价格减去期权费后再乘以每份期权合约所包含的合约标的资产的数量；（2）如果合约标的资产价格高于执行价格，看跌期权卖方就会亏损，其最大亏损是期权费总额。"
        },
        {
            "title": "关于银行间债券市场全额结算，以下表述正确的是（　　）。",
            "question": "A. 全额结算可以分为中央对手净额结算和非中央对手方净额结算两种模式\nB. 全额结算过程中，结算机构会参与到结算中，并对结算完成进行担保\nC. 全额结算要求指定时间段内所有的结算都顺利进行，如果有某个参与者无法进行结算，则会对其他参与者的结算带来影响，甚至导致整个交易的系统性风险\nD. 全额结算会对频繁交易的做市商有较高的资金需求，其资金负担较大，结算成本较高",
            "answer": "D",
            "explain": "本题考查全额结算。A选项说法错误，按照结算机构在结算中是否担当中央对手方，多边净额结算可以分为中央对手方净额结算和非中央对手方净额结算两种方式；B选项说法错误，全额结算过程中，结算机构并没有参与到结算中去，不对结算完成进行担保；C选项说法错误，由于交易双方是一一对应的，每个市场参与者都可监控自己参与的每一笔交易结算进展情况，从而评估自身对不同对手方的风险暴露，有利于保持交易的稳定和结算的及时性，降低结算本金风险。"
        },
        {
            "title": "想要了解某一时期企业管理费用的情况，应该查看（　　）。",
            "question": "A. 利润表\nB. 资产负债表\nC. 所有者权益变动表\nD. 现金流量表",
            "answer": "A",
            "explain": "本题考查利润表的作用。利润表有如下作用：（1）评价企业的经营绩效；（2）评价各部类业绩成长对企业总盈余的贡献度；（3）通过对收入、成本费用的分析，解析企业获利能力高低的原因，评价企业是否具有可持续发展能力。"
        },
        {
            "title": "以下关于沪深300指数的说法，正确的是（　　）。",
            "question": "A. 基于在上海和深圳证券市场中选取300只A股股票作为样本编制\nB. 基点为0点\nC. 是由证监会编制，反映A股市场整体走势的指数\nD. 以2004年11月1日为基期",
            "answer": "A",
            "explain": "本题考查证券价格指数。沪深300指数是由中证指数有限公司编制，用以反映A股市场整体走势的指数，在上海和深圳证券市场中选取300只A股作为样本，以2004年12月31日为基期，基点为1000点，其计算以调整股本为权重，采用派式加权综合价格指数公式进行计算。"
        },
        {
            "title": "2017年9月5日，证监会发布《中国证监会关于证券投资基金估值业务的指导意见》，其中关于管理人的估值技术的表达错误的是（　　）。",
            "question": "A. 基金管理人改变估值技术时，应当本着最大限度保护投资者利益的原则及时进行临时公告\nB. 基金管理人改变估值技术之前必须咨询会计事务所的专业意见\nC. 基金管理人应当明确基金估值的程序和技术\nD. 基金管理人改变估值技术时，应当在定期报告中披露",
            "answer": "B",
            "explain": "本题考查基金资产估值的原则。当改变估值技术导致基金资产净值的变化在0.25%以上的，基金管理人应就所采用的相关估值技术、假设及输入值的适当性等咨询会计师事务所的专业意见。"
        }, {
            "title": "因持有股票而享有的配股权，从配股除权日起到配股确认日止，如果股票收盘价低于配股价，则配股权的估值价格是（　　）。",
            "question": "A. 收盘价高于配股价的差额\nB. 配股价\nC. 零\nD. 收盘价",
            "answer": "C",
            "explain": "本题考查具体投资品种的估值方法。因持有股票而享有的配股权，从配股除权日起到配股确认日止，如果收盘价高于配股价，按收盘价高于配股价的差额估值。收盘价等于或低于配股价，则估值为零，C选项符合题意。"
        },
        {
            "title": "评估基金的业绩时需要考虑的方面包括（　　）。",
            "questions": "I. 计算绝对收益<br>II. 计算相对收益<br>III. 计算风险调整后收益<br>IV. 进行业绩归因",
            "question": "A. II、III、IV\nB. I、II、III\nC. I、II、III、IV\nD. I、II、IV",
            "answer": "C",
            "explain": "本题考查评估基金业绩时需考虑的方面。"
        },
        {
            "title": "关于银行间债券市场的净额结算，以下说法错误的是（　　）。",
            "question": "A. 是设定时间段内对市场参与者债券买卖净差额和资金净差额进行交收\nB. 有双边净额结算和多边净额结算两种方式\nC. 提高了市场参与者的流动性需求\nD. 提高了做市商市场运作效率",
            "answer": "C",
            "explain": "本题考查净额结算方式。净额结算在指定时间段内只有一个结算净额，从而降低了市场参与者的流动性需求、结算成本和相关风险。"
        },
        {
            "title": "某日a银行以x债务为履约担保，从b银行处融入了一笔资金，并约定在交易期内若x债券发生利息支付，则所支付利息归b银行所有，a银行与b银行交易的债券业务类型是（　　）。",
            "question": "A. 债券买断式回购业务\nB. 债券质押式回购业务\nC. 债券现券业务\nD. 债券借贷业务",
            "answer": "A",
            "explain": "本题考查买断式回购的概念。买断式回购期间资金融出方不仅可以获得回购期间融出的资金的利息收入，亦可以获得回购期间债券所有权和使用权。题干中，若x债券发生利息支付，则所支付和获得利息归b银行所有，即b银行获得回购期间债券所有权和使用权，业务类型为债券买断式回购业务。"
        },
        {
            "title": "下列不属于货币基金投资范围的是（　　）。",
            "question": "A. 剩余期限1年内的政策性金融债\nB. 剩余期限1年内的AAA级企业债\nC. 1年内银行定期存款\nD. 剩余期限1年内的可转换债券",
            "answer": "D",
            "explain": "本题考查货币基金的投资范围。货币基金是指以货币市场工具(包括银行拆借、短期国债、银行协议存款、短期融资券以及信用等级很高的短期票券等)为投资对象的基金。"
        },
        {
            "title": "关于报价驱动市场和指令驱动市场，以下表述错误的是（　　）。",
            "question": "A. 指令驱动市场由交易规则撮合\nB. 指令驱动市场交易者向经纪人下达交易指令\nC. 报价驱动市场买卖双方直接交易\nD. 报价驱动市场也称为做市商制度",
            "answer": "C",
            "explain": "本题考查报价驱动市场和指令驱动市场。报价驱动中，最为重要的角色就是做市商。做市商通常由具备一定实力和信誉的证券投资法人承担，本身拥有大量可交易证券，买卖双方均直接与做市商交易。"
        }, {
            "title": "企业破产时，以下几类投资者中最先获得企业资产清偿的是（　　）。",
            "question": "A. 企业股权持有人\nB. 次级债券持有人\nC. 优先无保证债券持有人\nD. 有保证债券持有人",
            "answer": "D",
            "explain": "本题考查债券违约时的受偿顺序。A选项不符合题意，企业股权持有人在企业资产清偿完所有债券人债务之后才获得企业资产。B、C选项不符合题意，无保证债券只是对债务人的资产有普遍的受偿权，在破产清偿时在有保证债券之后获得清偿，其中受偿等级最高的是优先无保证债券，接下来依次是优先次级债券、次级债券、劣后次级债券。"
        },
        {
            "title": "以下属于证券投资基金参与的证券交易所场内证券交易结算原则的是（　　）。",
            "question": "A. 见券付款原则\nB. 货银对付原则\nC. 货银机构优先原则\nD. 见款付券原则",
            "answer": "B",
            "explain": "本题考查场内证券交易结算的原则。场内证券交易结算原则包括：（1）法人结算原则；"
        },
        {
            "title": "关于股票的账面价值，以下表示错误的是（　　）。",
            "question": "A. 账面价值是股票投资价值分析的重要指标\nB. 账面价值是每股股票所代表的实际资产的价值\nC. 股票账面价值又称股票净值或每股净资产\nD. 盈利水平相同的前提下，账面价值越高，股票收益越高，股票越有投资价值",
            "answer": "C",
            "explain": "本题考查股票的价值与价格。股票的账面价值又称股票净值或每股净资产（C选项错误，不是每股总资产），是每股股票所代表的实际资产的价值（B选项正确）。在没有优先股的条件下，每股账面价值以公司净资产除以发行在外的普通股票的股数求得。公司的净资产是公司营运的资本基础。"
        },
        {
            "title": "下列选项不能直接从财务报表获得的是（　　）。",
            "question": "A. 净利润\nB. 净资产收益率\nC. 所有者权益\nD. 经营活动产生的现金流量",
            "answer": "B",
            "explain": "本题考查各财务报表中的科目。A选项不符合题意，净利润可直接在利润表中获得。B选项符合题意，净资产收益率也称权益报酬率，强调每单位所有者权益能够带来的利润，用来衡量企业最大化股东财富的能力，是根据公式：净资产收益率=销售利润率×总资产周转率×权益乘数得到的，无法直接从财务报表中获得。"
        },
        {
            "title": "基金P、Q、M和N相对于股市大盘的贝塔(β)值分别为-0.8，-0.3，0.6和3，若投资者预期股市将步入牛市，为获取更高收益率，则优势最大的是（　　）。",
            "question": "A. 基金Q\nB. 基金N\nC. 基金P\nD. 基金M",
            "answer": "B",
            "explain": "本题考查风险指标。系数是评估证券或投资组合系统性风险的指标，反映的是投资对象对市场变化的敏感度。β系数大于0时，该投资组合的价格变动方向与市场一致；β系数小于0时，该投资组合的价格变动方向与市场相反。β系数等于1时，该投资组合的价格变动幅度与市场一致；β系数大于1时，该投资组合的价格变动幅度比市场更大；β系数小于1(大于0)时，该投资组合的价格变动幅度比市场小。"
        },
        {
            "title": "一只基金的月平均净值增长率为4%，标准差为3%，在标准正态分布下，在95%的概率下，月度净值增长率处于（　　）。",
            "question": "A. 7%~1%\nB. 13%~-5%\nC. 10%~-2%\nD. 7%~-1%",
            "answer": "C",
            "explain": "本题考查股票基金的标准差。基金月度净值增长率为4%，标准差为3%，根据标准正态分布表，在95%的概率下，月度净值增长率会出现在2个标准差的偏离范围内，因此基金月度净值增长率为+10%~-2%。"
        }, {
            "title": "小张持有某上市公司发行的累积优先股共5000股，没有该公司其他权益资产，该优先股股息率为7%，每股票面价值为100元，以下表述错误的是（　　）。",
            "question": "A. 小张每年可能从上市公司分得股息35000元\nB. 如果当年该公司经营不善而未能分配股息，未分的股息不能累计，以后也不能补付\nC. 在公司破产的情况下，对于剩余财产的分配顺序小张优先于其他普通股股东\nD. 小张对该公司举办的股东大会不享有投票权",
            "answer": "B",
            "explain": "本题考查累积优先股。累积优先股通常承诺一个固定的股息，任何未支付的股息可以累积起来在普通股持有人收到股息前，用以后年度的盈利一起付清。B选项说法错误。"
        },
        {
            "title": "关于银行间债券市场做市商制度，下列说法错误的是（　　）。",
            "question": "A. 做市商就特定债券的买卖价格进行双向报价\nB. 做市商充当居中撮合者，合市场参与者达成交易\nC. 做市商承担债券价格变动的风险\nD. 做市商由具备一定实力和信誉的市场参与者担任",
            "answer": "B",
            "explain": "本题考查做市商制度。A、D选项说法正确，做市商制度指在债券市场上，由具有一定实力和信誉的市场参与者作为特许交易商，不断向投资者报出某些特定债券的买卖价格，双向报价并在该价位上接受投资者的买卖要求，以其自有资金和债券与投资者进行交易的制度。B选项说法错误，经纪人(并非做市商)充当居中撮合者，撮合市场参与者达成交易。C选项说法正确，因为做市商以其自有资金和债券与投资者进行交易，所以做市商承担债券价格变动的风险。"
        },
        {
            "title": "技术分析方法通过分析各种指标研究市场，以下哪一项不是技术分析的对象（　　）。",
            "question": "A. 财务报表\nB. 涨跌幅\nC. 成交量\nD. 价格",
            "answer": "A",
            "explain": "本题考查技术分析。技术分析是指通过研究金融市场的历史信息（股价、成交量、涨跌幅、图形走势等）来预测股票价格的趋势。财务报表不是技术分析的对象，A选项符合题意。"
        },
        {
            "title": "已知1年和2年期的即期利率分别为8%和10%，则第二年的远期利率为（　　）。",
            "question": "A. 10%\nB. 6.04%\nC. 12.04%\nD. 12%",
            "answer": "C",
            "explain": "本题考查远期利率的计算。根据远期利率的公式：f = ((1 + S2)^2 / (1 + S1)^1) - 1，其中，S1为1年期利率，S2为2年期利率，f为远期利率，已知S1=8%，S2=10%，根据公式计算得出远期利率为12.04%。"
        },
        {
            "title": "以下选项中，属于基础原材料类大宗商品的是（　　）。",
            "questions": "I. 钢铁、铜、铝<br>II. 橡胶、黄金、白银<br>III. 玉米、土豆、棕榈油<br>IV. 铅、锌、铁矿石",
            "question": "A. I、II\nB. I、IV\nC. II、IV\nD. II、III",
            "answer": "B",
            "explain": "本题考查大宗商品的类型。基础原材料类大宗商品主要包括钢铁、铜、铝、铅、锌、镍、钨、橡胶、铁矿石等，是制造业发展的基础，与生产经营活动密切相关。综上所述，I、IV项符合题意。"
        },
        {
            "title": "以下哪个债券的麦考利久期最长（　　）。",
            "question": "A. 15年到期、息票率为5%\nB. 10年到期、息票率为8%\nC. 15年到期、息票率为7%\nD. 10年到期、息票率为10%",
            "answer": "A",
            "explain": "本题考查麦考利久期的计算。麦考利久期的计算过程是计算每次支付金额的现值占当前债券价格的比率，然后以此比例为权重，乘以每次支付的期限，得到每次支付的加权期限。再将每次的加权期限加总，即得到债券的久期。"
        }, {
            "title": "风险投资是私募股权投资的形式之一。以下关于风险投资的表述错误的是（　　）。",
            "question": "A. 风险投资的主要收益来源是所投资企业的利润分配\nB. 多数风险投资在投资初期没有投资回报\nC. 风险投资主要投资于初创型公司\nD. 与成长权益战略相比，风险投资具有更高风险",
            "answer": "A",
            "explain": "本题考查私募股权投资的战略形式。风险资本的投资目的并不是取得对企业的长久控制权以及获得企业的利润分配，而是通过资本的退出，从股权增值当中获取高回报。"
        },
        {
            "title": "下面关于沪股通和港股通的说法正确的是（　　）。",
            "question": "A. 所谓沪股通就是投资者委托香港经纪商，经由香港联合交易所设立的证券交易服务公司，向上海证券交易所进行申报，买卖规定范围内的上海证券交易所上市的股票\nB. 所谓港股通，就是投资者委托内地证券服务公司，经由上海证券交易所设立的证券交易服务公司，向香港联合交易所进行申报，买卖规定范围内的上海证券交易所上市的股票\nC. 所谓沪股通，就是投资者委托内地证券服务公司，经由上海交易所设立的证券交易服务公司，向香港联合交易所进行申报，买卖规定范围内的香港联合交易所上市的股票\nD. 所谓港股通，就是投资者委托香港经纪商，经由香港联合交易所设立的证券交易服务公司，向上海交易所进行申报，买卖规定范围内的上海证券交易所上市的股票",
            "answer": "A",
            "explain": "本题考查沪股通和港股通的定义。"
        },
        {
            "title": "关于投资组合管理的基本步骤，以下选项错误的是（　　）。",
            "question": "A. 投资规划的首要任务就是优化投资组合\nB. 投资政策说明书是所有投资决策制定的指导性文件\nC. 投资管理人结合投资政策说明书和资本市场预期来决定各类目标资产的配置\nD. 投资管理人对多种资产类别的长期风险和收益特征进行预测",
            "answer": "A",
            "explain": "本题考查投资组合管理步骤中的规划。A选项错误，投资规划的首要任务是了解客户需求，确认并量化投资者的投资目标和投资限制。"
        },
        {
            "title": "某公司发行普通股1亿股，每股面值1元，每股发行价3元，则下列说法错误的是（　　）。",
            "question": "A. 本次共募集资金3亿元\nB. 计入所有者权益1亿元\nC. 计入资本公积2亿元\nD. 本次发行时溢价发行",
            "answer": "B",
            "explain": "本题考查股票的价值与价格。A选项说法正确，募集的资金=每股发行价×发行数量=3×1=3亿元。B选项说法错误，C选项说法正确，等于面值的部分计入股本每股面值×发行数量=1亿元，超额部分计入资本公积=3-1=2亿元。所有者权益是指企业总资产中扣除负债所余下的部分，题中计入所有者权益的部分=股本+资本公积=3亿元。D选项说法正确，发行价格高于面值称为溢价发行，题干中每股面值1元，每股发行价3元，即本次发行时溢价发行。"
        },
        {
            "title": "基金运营过程中发生的增值税的纳税主体是（　　）。",
            "question": "A. 券商\nB. 基金管理人\nC. 沪深交易所\nD. 基金托管人",
            "answer": "B",
            "explain": "本题考查基金自身投资活动产生的增值税的纳税主体。2016年12月财政部、国家税务总局发布的《关于明确金融、房地产开发、教育辅助服务等增值税政策的通知》规定：'资管产品运营过程中发生的增值税应税行为，以资管产品管理人为增值税纳税人'。"
        },
        {
            "title": "关于主动投资和被动投资，以下表述正确的是（　　）。",
            "question": "A. 被动投资通过市场择时获得超额收益\nB. 主动投资在强有效市场比在弱有效市场更有优势\nC. 主动投资和被动投资是完全对立的\nD. 被动投资试图复制某一业绩基准，主动投资试图跑赢市场",
            "answer": "D",
            "explain": "本题考查被动投资和主动投资。被动投资试图复制某一业绩基准，主动投资试图跑赢市场。"
        }, {
            "title": "关于可转债投资的风险，以下表述正确的是（　　）。",
            "questions": "I. 持有者不用承担股价波动的风险<br>II. 投资者不会有利息损失风险<br>III. 可转债规定发行者可以在发行一段时间后以某价格赎回债券，因而投资者要承担再投资风险<br>IV. 我国可转债的部分品种具有强制性转股条款，这将给投资者带来转换风险",
            "question": "A. I、III、IV\nB. I、II、III\nC. I、II\nD. III、IV",
            "answer": "D",
            "explain": "本题考查可转债的特定风险。"
        },
        {
            "title": "关于房地产投资信托(REITs)，以下表述错误的是（　　）。",
            "question": "A. 房地产投资信托具有较大的通货膨胀风险，通货膨胀会带来严重的不利影响\nB. 房地产投资信托是经证券化的房地产投资，可在交易市场上交易，具有较强的流动性\nC. 上市的房地产信托须定期进行信息披露，降低了信息不对称程度\nD. 与房地产公司股票相比，房地产投资信托的波动性更低",
            "answer": "A",
            "explain": "本题考查房地产投资信托(REITs)。房地产投资信托(基金)(realestateinvestmenttrusts，REITs)，是指通过发行受益凭证或者股票来进行募资，并将这些资金投资到房地产或者房地产抵押贷款的专门投资机构。"
        },
        {
            "title": "关于买卖价差，以下表述正确的是（　　）。",
            "question": "A. 大盘蓝筹股股价较高，买卖价差较大\nB. 流动性好的股票，买卖差较小\nC. 总体而言，发达国家股票市场参与者较多，买卖价差较大\nD. 买卖价差无法通过交易择时控制",
            "answer": "B",
            "explain": "本题考查买卖价差的特点。A选项表述错误，B选项表述正确，一般而言，大盘蓝筹股流动性较好，买卖价差小；小盘股则反之。C选项表述错误，发达国家股票市场参与者较多，价差较小而新兴市场买卖价差则较大。"
        },
        {
            "title": "证券公司在向客户融资、融券前，应当与其签订融资融券服务合同，以下哪些内容是需要在合同中明确的（　　）。",
            "questions": "I. 保证金比例<br>II. 维持担保比例<br>III. 追加保证金的期限<br>IV. 可充抵保证金的证券的种类及折算率",
            "question": "A. I、II、III、IV\nB. I、II、III\nC. I、III、IV\nD. II、III、IV",
            "answer": "A",
            "explain": "本题考查保证金交易。"
        },
        {
            "title": "关于股票的价值和价格，以下表述正确的是（　　）。",
            "question": "A. 以股票的账面价值发行称为平价发行\nB. 股票的市场价格由股票的清算价值决定\nC. 股票的价值取决于未来收益的大小\nD. 股票的市场价格总是围绕其账面价值波动",
            "answer": "C",
            "explain": "本题考查股票的价值和价格。"
        },
        {
            "title": "为实现避险策略，避险策略基金需符合的要求不包括（　　）。",
            "question": "A. 投资于稳健资产不得低于基金资产净值的80%\nB. 稳健资产投资组合的平均剩余期限不得低于剩余避险策略周期\nC. 基金管理人应审慎建立风险资产投资对象备选库\nD. 基金管理人应审慎确定风险资产的投资比例",
            "answer": "B",
            "explain": "本题考查避险策略基金的要求。避险策略基金的要求包括：(1) 避险策略基金投资于稳健资产不得低于基金资产净值的80%，以获取稳定收益，尽力避免到期时投资本金出现亏损(A选项不符合题意) (2) 稳健资产投资组合的平均剩余期限不得超过剩余避险策略周期(B选项符合题意)"
        }, {
            "title": "在现值的计算中，利率也称为（　　）。",
            "question": "A. 名义利率\nB. 股息率\nC. 贴现率\nD. 利滚利",
            "answer": "C",
            "explain": "本题考查贴现率的概念。A选项不符合题意，名义利率是指包含对通货膨胀补偿的利率，当物价不断上涨时，名义利率比实际利率高。B选项不符合题意，股息率是股息与股票价格之间的比率。"
        },
        {
            "title": "会导致指数复制时出现跟踪误差的因素包括（　　）。",
            "questions": "I. 现金留存<br>II. 基金管理费<br>III. 证券交易产生的佣金<br>IV. 证券交易产生的印花税",
            "question": "A. II、III、IV\nB. I、II、III\nC. I、II、III、IV\nD. I、III、IV",
            "answer": "C",
            "explain": "本题考查跟踪误差产生的原因。跟踪误差产生的原因："
        },
        {
            "title": "关于单利、复利，以下表述错误的是（　　）。",
            "question": "A. 不论单利还是复利，都与贴现是相反的过程\nB. 随着时间的增长，利息率相同的情况下，单利和复利的利息差距逐渐扩大\nC. 对于单利，本金在计息周期中获得的利息不加入本金重复计算利息\nD. 对于复利，本金在计息周期中获得的利息加入本金再计利息",
            "answer": "A",
            "explain": "本题考查单利与复利。将未来某时点资金的价值折算为现在时点的价值称为贴现，只有复利计算与贴现是相反的过程。"
        },
        {
            "title": "关于下行标准差，以下表述错误的是（　　）。",
            "question": "A. 如果投资组合在考察期间一直超越目标，则计算下行标准差找不到足够的数据点进行计算\nB. 计算下行标准差时需要知道目标收益率\nC. 通常需要对下行标准差进行年化处理\nD. 下行标准差关注波动率低于目标的风险",
            "answer": "D",
            "explain": "本题考查下行标准差。A选项表述正确，下行标准差的局限性在于计算时需要获取足够多的收益低于目标的数据。如果投资组合在考察期间表现一直超越目标，该指标将得不到足够的数据点进行计算。"
        },
        {
            "title": "根据基金估值方面的法规要求，基金管理公司应做到（　　）。",
            "questions": "I. 制定健全有效的估值政策和程序<br>II. 建立相关的信息披露制度和内部控制制度<br>III. 一旦确定估值方法，不得进行变更<br>IV. 在估值方法和调整幅度做出重大变化时进行公告和解释",
            "question": "A. I、II、III\nB. I、II\nC. I、II、III、IV\nD. I、II、IV",
            "answer": "D",
            "explain": "本题考查基金估值的法规要求。根据《关于进一步规范证券投资基金估值业务的指导意见》的要求，基金管理公司应做到："
        },
        {
            "title": "某基金公司为更好的服务VIP客户，要求交易员在基金投资交易过程中优先执行VIP客户持仓的投资组合的交易指令。关于该公司行为以下表述正确的是（　　）。",
            "question": "A. 该行为将触发操作风险\nB. 该行为将触发政策风险\nC. 该行为属于正常的营销业务手段，但应进行相应的信息披露\nD. 该行为将触发合规风险",
            "answer": "D",
            "explain": "本题考查合规风险。合规风险是指违反法律、法规、交易所规则、公司内部制度、基金合同等导致公司可能遭受法律制裁、监管处罚、公开谴责等的风险。"
        }, {
            "title": "若债券截明的年利率为6%，远期利率为3%，通货膨胀率为2%，则投资者获得的实际利率为（　　）。",
            "question": "A. 4%\nB. 9%\nC. 8%\nD. 3%",
            "answer": "A",
            "explain": "本题考查名义利率和实际利率的关系。根据费雪方程式，实际利率=名义利率-通货膨胀率。本题中，名义利率即年利率为6%，通货膨胀率为2%。代入数值可得实际利率=6%-2%=4%。"
        },
        {
            "title": "某基金管理人统计了某个基金产品100个交易日的每天净值变化基点值（单位点），并将+从小到大依次排列分别为：（1）-（100），其中，+（91）-（100）为15.75, 16.34, 16.78, 16.85, 17.12, 17.56, 18.41, 18.57, 18.87, 18.99，则+的上2.5%分位数为（　　）。",
            "question": "A. 16.78\nB. 18.72\nC. 16.56\nD. 16.34",
            "answer": "B",
            "explain": "本题考查分位数的计算。上分位数：从大到小排；下分位数：从小到大排"
        },
        {
            "title": "关于商业票据，以下表述正确的是（　　）。",
            "questions": "I. 是发行主体为满足流动资金需求所发行的期限为2至270天，可流通转让的债务工具<br>II. 是获取短期信贷的债务工具，广义上包括商业汇票和商业本票，狭义上仅指商业本票<br>III. 主要特点有：面额较大、利率较低、流动性好<br>IV. 采取贴现发行方式，资信良好的发行人可采取直接发行",
            "question": "A. I、II、IV\nB. I、II、III\nC. I、III、IV\nD. II、III、IV",
            "answer": "A",
            "explain": "本题考查商业票据。I项表述正确，商业票据是指发行主体为满足流动资金需求所发行的期限为2至270天，可流通转让的债务工具。"
        },
        {
            "title": "关于银行间债券市场见券付款的结算方式，以下说法错误的是（　　）。",
            "question": "A. 付券方有一个风险敞口\nB. 等到日终券仍不足时，生成失败交割单\nC. 通常收券方信用比收款方好\nD. 券足等款到日终仍无付款指令时，生成失败交割单，下一交易日解冻债券",
            "answer": "D",
            "explain": "本题考查见券付款的结算方式。对于见券付款，券足等款到日终仍无付款指令时，生成失败交割单，并解冻债券（并非下一交易日解冻债券）。故本题选D选项。"
        },
        {
            "title": "某投资者预期未来一段时间铜价将会下跌，则该投资者最不可能采用的策略是（　　）。",
            "question": "A. 卖出仓库中储存的现货铜\nB. 将其持有的某期货交易所的期货铜多头头寸平仓\nC. 买入某铜矿公司的股票因此公司披露将铜价波动风险对冲\nD. 买入某金融机构发行的挂钩铜期货且看空铜价的结构化产品",
            "answer": "C",
            "explain": "本题考查期货合约。当投资者预期未来一段时间铜价将会下跌时，会卖出现货或做空铜期货。"
        },
        {
            "title": "关于场内证券交易结算的共同对手方制度，以下说法中错误的是（　　）。",
            "question": "A. 卖出证券的投资者相当于将证券卖给了共同对手方，买入证券的投资者相当于从共同对手方买入证券\nB. 如果买卖双方中的一方不能履约交收，共同对手方会暂时冻结卖出方的证券或买入方的资金，直到另一方履约时，再完成交收\nC. 共同对手方是指在结算过程中同时作为所有买方和卖方的交收对手，并保证交收顺利完成的主体\nD. 共同对手方一般由证券登记结算机构充当",
            "answer": "B",
            "explain": "本题考查共同对手方制度。在共同对手方制度中，如果买卖双方中的一方不能按约定条件履约交收，结算机构也要依照结算规则向守约一方先行垫付其应收的证券或资金，B选项说法错误。"
        },
        {
            "title": "某附息国债面值为100元，票面利率为8%，市场利率为5%，期限2年，每年付息一次，该国债的内在价值为（　　）。",
            "question": "A. 108.58元\nB. 90.85元\nC. 110.85元\nD. 105.58元",
            "answer": "D",
            "explain": "本题考查固定利率债券估值法。国债的内在价值计算公式为：V = C/(1+R) + C/(1+R)^2 + ... + (C+M)/(1+r)^n，式中V表示固定利率债券的内在价值，C表示每期支付的利息，M表示面值，r表示市场利率，n表示债券到期时间。"
        },
        {
            "title": "某些投资者将控制最大回撤作为投资的重要指标，目的是（　　）。",
            "question": "A. 控制损失发生的可能频率\nB. 将损失控制在相对于其投资期间最大财富的一个固定比例\nC. 预测未来利益\nD. 控制收益向上以及向下波动的幅度",
            "answer": "B",
            "explain": "本题考查最大回撤。某些投资者将控制最大回撤作为投资的重要指标，目的是将损失控制在相对于其投资期间最大财富的一个固定比例。"
        },
        {
            "title": "一般来说，信用利差出现变化一般发生在经济周期转变（　　）。",
            "question": "A. 之前\nB. 之后\nC. 无法确定\nD. 之中",
            "answer": "A",
            "explain": "本题考查信用利差的特点。信用利差的变化本质上是市场风险偏好的变化，受经济预期影响，从实际数据来看，信用利差的变化一般发生在经济周期发生转变之前，因此，信用利差可以作为预测经济周期活动的指标，A选项符合题意。"
        },
        {
            "title": "关于全球投资业绩标准(GIPS)中收益率的具体计算，以下表述正确的是（　　）。",
            "question": "A. GIPS要求计算总收益率\nB. 投资组合的收益必须以期末资产值加权计算\nC. 自2010年1月1日起，必须至少每季度一次计算组合群收益\nD. 自2005年1月1日起，必须采用经每日加权现金流调整后的资金加权收益率来计算总收益率",
            "answer": "A",
            "explain": "本题考查GIPS收益率计算的规定。A选项表述正确，必须采用总收益率，即包括实现的和未实现的回报以及损失并加上收入。"
        },
        {
            "title": "关于期货合约，以下表述正确的包括（　　）。",
            "questions": "I. 只在交易所交易<br>II. 通常实物交割<br>III. 存在杠杆效应<br>IV. 信用风险高",
            "question": "A. I、III\nB. I、II\nC. II、IV\nD. III、IV",
            "answer": "A",
            "explain": "本题考查期货合约。I项说法正确，期货合约只在交易所交易；"
        },
        {
            "title": "关于债券的估值方法，以下表述正确的是（　　）。",
            "question": "A. 交易所上市交易的债券采用收盘价估值\nB. 对在交易所上市交易的可转换债券按当日收盘价作为估值净价\nC. 全国银行间债券市场交易的债券采用第三方估值机构提供价格估值\nD. 中小企业私募债券采用第三方估值机构提供价格估值",
            "answer": "C",
            "explain": "本题考查交易所上市交易的非流通受限品种的估值。C选项表述正确，全国银行间债券市场交易的固定收益品种，采用第三方估值机构提供的相应品种当日的估值价格。"
        }, {
            "title": "关于麦考利久期，以下表述正确的是（　　）。",
            "question": "A. 麦考利久期从现值角度度量了债券现金流的加权平均年限\nB. 麦考利久期从现值角度度量了债券现金流的算术平均年限\nC. 麦考利久期从终值角度度量了债券现金流的算术平均年限\nD. 麦考利久期从终值角度度量了债券现金流的加权平均年限",
            "answer": "A",
            "explain": "本题考查麦考利久期的作用。麦考利久期从现值角度度量了债券现金流的加权平均年限，A选项符合题意。"
        },
        {
            "title": "银行间债券市场中，债券远期交易从成交日至结算日的期限最长不得超过（　　）天。",
            "question": "A. 365\nB. 360\nC. 180\nD. 120",
            "answer": "A",
            "explain": "本题考查远期交易的交易期限。银行间债券市场中，债券远期交易从成交日至结算日的期限最长不得超过365天。"
        },
        {
            "title": "假设某只基金只持有四类股票，数量分别为50万股、60万股、80万股、100万股，每股的收盘价分别为15元、20元、35元、5元，银行存款为1000万元，应交税费为1750万元，已售出基金份额为3000万份，假设基金没有其他资产负债，则基金份额净值为（　　）。",
            "question": "A. 1.50元\nB. 1.83元\nC. 1.1元\nD. 1.33元",
            "answer": "A",
            "explain": "本题考查基金份额净值的计算。基金资产净值=基金资产-基金负债；基金份额净值=基金资产净值/基金总份额。将题中数值代入公式可得，基金资产净值=(50*15+60*20+80*35+100*5+1000)-1750=4500(万元)，则基金份额净值=4500/3000=1.50(元)。"
        },
        {
            "title": "沪深300股期货最低交易保证金是合约价值的8%，据此购入300股期货可以控制（　　）倍于所投资金额的合约资产。",
            "question": "A. 30\nB. 8\nC. 12.5\nD. 20",
            "answer": "C",
            "explain": "本题考查期货合约的杠杆性。沪深300股期货最低交易保证金是合约价值的8%，据此购入300股期货可以控制12.5(1+8%=12.5)倍于所投资金额的合约资产。"
        },
        {
            "title": "规避跨境投资中汇率风险的方法是（　　）。",
            "question": "A. 降低外币资产的交易频率\nB. 降低申赎频率\nC. 控制基金投资规模\nD. 投资外汇远期合约",
            "answer": "D",
            "explain": "本题考查跨境投资风险管理。跨境投资的风险管理方法之一是多币种投资和汇率避险操作相结合。QDII基金投资于全球多币种市场，不仅可有效降低投资单一市场所面临的汇率风险，还可分享比人民币走势更好的货币对人民币升值带来的好处。此外，QDII基金还可通过一些外汇远期合约和货币交换等衍生工具来进行汇率的风险操作。"
        },
        {
            "title": "《公开募集证券投资基金运作管理》规定，封闭式基金年度收益分配比例不得低于基金年度可供分配利润的（　　）。",
            "question": "A. 80%\nB. 100%\nC. 可根据基金合同的规定\nD. 90%",
            "answer": "D",
            "explain": "本题考查封闭式基金的利润分配。《公开募集证券投资基金运作管理》规定，封闭式基金年度收益分配比例不得低于基金年度可供分配利润的90%。"
        },
        {
            "title": "关于房地产有限合伙，以下表述错误的是（　　）。",
            "question": "A. 房地产有限合伙的流动性比较差，资金难以在短期内退出\nB. 管理人作为合伙人之一，不收取管理费，而参与收益分红\nC. 普通投资者作为有限合伙人出资，并以出资额为限承担责任\nD. 房地产开发公司作为普通合伙人和管理人，负责投资运作",
            "answer": "B",
            "explain": "本题考查房地产有限合伙。房地产普通合伙人和私募股权当中的普通合伙人一样，收取固定比例的管理费，同时，做决策时不会受到太大的干扰。B选项说法错误。"
        }, {
            "title": "有关基金估值，托管人应复核、审查基金管理公司计算的数据中不包括（　　）。",
            "question": "A. 基金份额申购价格\nB. 基金资产净值\nC. 基金份额赎回价格\nD. 每位基金持有人的持有份额",
            "answer": "D",
            "explain": "本题考查基金估值程序托管人的责任。A、B、C选项不符合题意，托管人进行复核时计算的数据不包括每位基金持有人的持有份额。D选项符合题意，基金托管人进行复核时计算的数据不包括每位基金持有人的持有份额。"
        },
        {
            "title": "只有本金在计息周期中获得利息，无论时间多长，所生利息均不加入本金重复计算利息。这是哪种计息方式（　　）。",
            "question": "A. 固定利率\nB. 单利\nC. 浮动利率\nD. 复利",
            "answer": "B",
            "explain": "本题考查单利的概念。单利是计息周期的一种方法，按照这种方法，只有本金在计息周期中获得利息，无论时间多长，所生利息均不加入本金重复计算利息。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/5/jjjc-4.js